import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { adminDashboard, errors } = copy;
const {
  customSubscriptions: { fields: fieldsCopy },
} = adminDashboard;

export const getFields = (): IFormFields => [
  {
    name: "amount",
    label: fieldsCopy.amount,
    type: IFieldType.number,
    validation: {
      required: errors.required,
    },
    style: {
      gridColumn: "span 2",
      mobile: {
        gridColumn: "span 1",
      },
    },
  },
  {
    name: "start",
    label: fieldsCopy.start,
    type: IFieldType.simpleDate,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "stop",
    label: fieldsCopy.stop,
    type: IFieldType.simpleDate,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "invoiceUrl",
    label: fieldsCopy.invoiceUrl,
    type: IFieldType.website,
    validation: {
      required: errors.required,
    },
    style: {
      gridColumn: "span 2",
      mobile: {
        gridColumn: "span 1",
      },
    },
  },
  {
    name: "invoiceNumber",
    label: fieldsCopy.invoiceNumber,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "invoiceDate",
    label: fieldsCopy.invoiceDate,
    type: IFieldType.simpleDate,
    validation: {
      required: errors.required,
    },
  },
];
